<template>
  <div id="roleSetting">
    <div id="search" class="filter-container">
      <el-input v-model="listQuery.roleName" class="input-with-select" clearable :placeholder="$t('adminView.RoleName')" @clear="searchTable">
        <el-button slot="append" icon="el-icon-search" @click="searchTable" />
      </el-input>
      <el-button class="filter-item" icon="el-icon-plus" style="margin: -2px 0 0 0;" type="primary" @click="add" />
      <!-- <el-button class="filter-item" type="primary" icon="el-icon-delete" style="margin: -2px 0 0 0;" @click="deleteItems" /> -->
    </div>
    <div>
      <el-table v-loading.body="listLoading" :data="list" border element-loading-text="Loading" fit highlight-current-row @selection-change="selectChange">
        <el-table-column align="center" type="selection" width="95" />
        <el-table-column align="center" :label="$t('adminView.RoleName')+' ('+$t('i18nPage.zh')+')'">
          <template slot-scope="scope">
            <span>{{ scope.row.roleNameZh }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('adminView.RoleName')+' ('+$t('i18nPage.English')+')'">
          <template slot-scope="scope">
            <span>{{ scope.row.roleName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('yhubReport.Operating')">
          <template slot-scope="scope">
            <!-- <el-button slot="append" icon="el-icon-edit" @click="edit(scope.row)" /> -->
            <el-button class="filter-item" icon="el-icon-edit" size="mini" type="primary" @click="edit(scope.row)" />
          </template>
        </el-table-column>
      </el-table>

      <!-- 列表模块————分页 -->
      <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
        <div class="pagination-container">
          <el-pagination v-if="pageshow" :page-size="listQuery.pageInfo.limit" :page-sizes="listQuery.pageInfo.pageList" :total="listQuery.pageInfo.total" background current-page.sync="listQuery.pageInfo.page" layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" @size-change="handleSizeChange" />
        </div>
      </div>
      <!-- 弹窗 -->
      <div>
        <el-dialog :close-on-click-modal="false" :title="dialogStatus" :visible.sync="dialogFormVisible">
          <el-form ref="dataForm" :model="dataModel" :rules="rules" label-position="left" label-width="200px" style="width: 400px; margin-left:50px;">
            <el-form-item :label="$t('adminView.RoleName')+' ('+$t('i18nPage.zh')+')'" prop="roleNameZh">
              <el-input v-model="dataModel.roleNameZh" />
            </el-form-item>
            <el-form-item :label="$t('adminView.RoleName')+' ('+$t('i18nPage.English')+')'" prop="roleName">
              <el-input v-model="dataModel.roleName" />
            </el-form-item>
          </el-form>
          <el-tree ref="tree" :data="menuData" :props="defaultProps" default-expand-all highlight-current node-key="menuId" show-checkbox />
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">{{ $t('button.Cancel') }}</el-button>
            <el-button type="primary" @click="submitPop">{{ $t('button.Submit') }}</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { rolePageList, roleInsert, roleDeleteById, roleDeleteByIds, getPermission, getMenuIdsByRoleId, update } from '@/api/roleAndMenu'
import { pagination } from '@/utils/init_table'
import i18n from '@/i18n'

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      list: null,
      listLoading: true,
      // 分页----start
      listQuery: {
        roleNameZh: null,
        roleName: null,
        pageInfo: pagination()
      },
      pageshow: true,
      // 分页----end
      dialogStatus: '',
      dataModel: {
        roleNameZh: null,
        roleName: null,
        menuId: null,
        treeNodes: null
      },
      textMap: {
        update: 'Edit',
        create: 'Create'
      },
      dialogFormVisible: false,
      itemIds: null,
      menuData: [],
      defaultProps: {
        label: 'permissionName'
      },
      defaultChecked: [24],
      isAdd: true
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    },
    rules() {
      return {
        roleNameZh: [{ required: true, message: i18n.t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        roleName: [{ required: true, message: i18n.t('lease.Cannotbeblanked2'), trigger: 'blur' }]
      }
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.rules.roleName[0].message = i18n.t('lease.Cannotbeblanked2')
    }
  },
  mounted() {
    this.queryList()
  },
  methods: {
    queryList() {
      this.listLoading = true
      var param = {
        roleName: this.listQuery.roleName,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      rolePageList(param).then(response => {
        if (response.resultCode == 1001) {
          this.list = response.resultModel.list
          this.listQuery.pageInfo.total = response.resultModel.total // 分页
          this.listLoading = false
        } else if (response.resultCode == 6001) {
          // 无操作权限
          this.$message({
            type: 'error',
            message: i18n.t('company.noPermission')
          })
        }
      })
    },
    searchTable() {
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    add() {
      this.resetTemp()
      this.dialogStatus = i18n.t('adminView.add')
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
      this.fillTree()
      this.isAdd = true
    },
    fillTree() {
      if (this.menuData === null || this.menuData.length <= 0) {
        this.listLoading = true
        getPermission(this.listQuery).then(response => {
          this.menuData = response.resultModel
          this.listLoading = false
          this.$refs.tree.setCheckedKeys([])
        })
      } else {
        this.$refs.tree.setCheckedKeys([])
      }
    },
    resetTemp() {
      for (var key in this.dataModel) {
        this.dataModel[key] = null
      }
    },
    submitPop() {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          this.dataModel.treeNodes = this.$refs.tree.getCheckedNodes()
          var nodes = this.$refs.tree.getHalfCheckedNodes()
          for (var index in nodes) {
            nodes.menuId = nodes.id
            this.dataModel.treeNodes.push(nodes[index])
          }
          if (this.isAdd) {
            roleInsert(this.dataModel).then(response => {
              this.dialogFormVisible = false
              this.queryList()
              this.$notify({
                title: '',
                message: i18n.t('lease.Succeed'),
                type: 'success',
                duration: 2000
              })
            })
          } else {
            update(this.dataModel).then(response => {
              this.dialogFormVisible = false
              this.queryList()
              this.$notify({
                title: '',
                message: i18n.t('lease.Succeed'),
                type: 'success',
                duration: 2000
              })
            })
          }
        }
      })
    },
    edit(row) {
      const _this = this
      this.resetTemp()
      this.dialogStatus = i18n.t('adminView.Edit')
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
      this.dataModel.id = row.id
      this.dataModel.roleName = row.roleName
      this.dataModel.roleNameZh = row.roleNameZh
      _this.listLoading = true
      this.isAdd = false
      // console.log('this.menuData---', this.menuData)
      if (this.menuData === null || this.menuData.length <= 0) {
        getPermission(this.listQuery).then(response => {
          _this.menuData = response.resultModel
          this.$refs.tree.setCheckedKeys([])
          getMenuIdsByRoleId({ id: row.id }).then(response => {
            const resultModel = response.resultModel
            if (resultModel !== null) {
              for (const i in resultModel) {
                console.info(resultModel[i])
                this.$refs.tree.setChecked(resultModel[i], true, false)
              }
            }
            _this.listLoading = false
          })
        })
      } else {
        this.$refs.tree.setCheckedKeys([])
        getMenuIdsByRoleId({ id: row.id }).then(response => {
          const resultModel = response.resultModel
          if (resultModel !== null) {
            for (const i in resultModel) {
              this.$refs.tree.setChecked(resultModel[i].menuId, true, false)
            }
          }
          _this.listLoading = false
        })
      }
    },
    // 分页----start
    handleSizeChange(val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) {
      // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    },
    // 分页----end
    selectChange(selection) {
      this.itemIds = selection
    },
    deleteItems() {
      if (!this.itemIds || this.itemIds.length === 0) {
        this.$message({
          type: 'info',
          message: i18n.t('adminView.SelectRecords')// '请选择需要删除的记录'
        })
        return
      }
      this.$confirm(i18n.t('adminView.ConfirmDelete'), '', {
        confirmButtonText: i18n.t('button.Confirm'), // '确定'
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      })
        .then(() => {
          if (this.itemIds) {
            var ids = []
            for (var itemKey in this.itemIds) {
              ids.push(this.itemIds[itemKey].id)
            }
            if (ids.length > 1) {
              roleDeleteByIds({ ids: ids }).then(response => {
                if (response.resultCode === 1001) {
                  this.itemIds = null
                  this.queryList()
                  this.$notify({
                    title: '',
                    message: i18n.t('lease.Succeed'),
                    type: 'success',
                    duration: 2000
                  })
                }
              })
            } else {
              roleDeleteById({ id: ids[0] }).then(response => {
                if (response.resultCode === 1001) {
                  this.itemIds = null
                  this.queryList()
                  this.$notify({
                    title: '',
                    message: i18n.t('lease.Succeed'),
                    type: 'success',
                    duration: 2000
                  })
                }
              })
            }
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: i18n.t('adminView.Canceled')// '已取消删除'
          })
        })
    }
  }
}
</script>

<style lang="scss">
#roleSetting {
  background: #fff;
  padding: 13px 20px;
  #search .el-input-group {
    width: 40% !important;
    max-width: 300px !important;
    // margin-top: 13px;
  }
}
</style>
